export function formatCurrency(locale, currency, amount) {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amount);
}

export function formatCurrencyInCents(locale, currency, amount) {
  return formatCurrency(locale, currency, amount / 100);
}

export default formatCurrency;
